import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget';
import { Plugin } from '@ckeditor/ckeditor5-core';
import InsertCopyableCommand from './copyable-command';
export default class CopyableEditing extends Plugin {
    init() {
        this.editor.commands.add('insertCopyable', new InsertCopyableCommand(this.editor));
        this._defineSchema();
        this._defineConverters();
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('copyable', {
            isObject: true,
            allowWhere: '$block',
        });
        schema.register('copyableLabel', {
            isLimit: true,
            allowIn: 'copyable',
            allowContentOf: '$block',
        });
        schema.register('copyableText', {
            isLimit: true,
            allowIn: 'copyable',
            allowContentOf: '$root',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.for('upcast').elementToElement({
            model: 'copyable',
            view: 'x-copyable',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'copyable',
            view: 'x-copyable',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'copyable',
            view: (modelElement, { writer }) => {
                const div = writer.createContainerElement('div', {
                    class: 'copyable',
                    placeholder: 'Adaptable example text',
                });
                return toWidget(div, writer, { label: 'Block with click to copy button' });
            },
        });
        conversion.for('upcast').elementToElement({
            model: 'copyableLabel',
            view: 'x-copyable-label',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'copyableLabel',
            view: 'x-copyable-label',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'copyableLabel',
            view: (modelElement, { writer }) => {
                const div = writer.createEditableElement('div', {
                    class: 'copyable__label',
                });
                return toWidgetEditable(div, writer);
            },
        });
        conversion.for('upcast').elementToElement({
            model: 'copyableText',
            view: 'x-copyable-text',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'copyableText',
            view: 'x-copyable-text',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'copyableText',
            view: (modelElement, { writer }) => {
                const div = writer.createEditableElement('div', {
                    class: 'copyable__text',
                });
                return toWidgetEditable(div, writer);
            },
        });
    }
}
